var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCalendarWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 14,
    viewBox: "0 0 13 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_583_1216)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.6458 2.66666L10.4722 2.66666V3.38889H11.5555L11.5555 11.3333L1.44442 11.3333L1.44442 3.38889L2.52776 3.38889V2.66666L1.35414 2.66666C1.26973 2.66807 1.18642 2.6861 1.10897 2.71971C1.03153 2.75333 0.961461 2.80187 0.902778 2.86256C0.844094 2.92326 0.797942 2.99492 0.766958 3.07346C0.735974 3.15199 0.720765 3.23586 0.7222 3.32028L0.7222 11.4019C0.720765 11.4864 0.735974 11.5702 0.766958 11.6488C0.797942 11.7273 0.844094 11.799 0.902778 11.8597C0.961461 11.9203 1.03153 11.9689 1.10897 12.0025C1.18642 12.0361 1.26973 12.0541 1.35414 12.0556L11.6458 12.0556C11.7302 12.0541 11.8135 12.0361 11.891 12.0025C11.9684 11.9689 12.0385 11.9203 12.0972 11.8597C12.1559 11.799 12.202 11.7273 12.233 11.6488C12.264 11.5702 12.2792 11.4864 12.2778 11.4019L12.2778 3.32028C12.2792 3.23586 12.264 3.15199 12.233 3.07346C12.202 2.99492 12.1559 2.92326 12.0972 2.86256C12.0385 2.80187 11.9684 2.75333 11.891 2.71971C11.8135 2.6861 11.7302 2.66807 11.6458 2.66666Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.88892 5.55556H3.61114V6.27778H2.88892V5.55556Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.05554 5.55556H5.77776V6.27778H5.05554V5.55556Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.22223 5.55556H7.94445V6.27778H7.22223V5.55556Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.38892 5.55556H10.1111V6.27778H9.38892V5.55556Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.88892 7.36111H3.61114V8.08334H2.88892V7.36111Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.05554 7.36111H5.77776V8.08334H5.05554V7.36111Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.22223 7.36111H7.94445V8.08334H7.22223V7.36111Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.38892 7.36111H10.1111V8.08334H9.38892V7.36111Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.88892 9.16666H3.61114V9.88889H2.88892V9.16666Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.05554 9.16666H5.77776V9.88889H5.05554V9.16666Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.22223 9.16666H7.94445V9.88889H7.22223V9.16666Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.38892 9.16666H10.1111V9.88889H9.38892V9.16666Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.61111 4.11111C3.70688 4.11111 3.79873 4.07306 3.86646 4.00534C3.93418 3.93762 3.97222 3.84577 3.97222 3.75L3.97222 1.58333C3.97222 1.48756 3.93418 1.39571 3.86646 1.32799C3.79873 1.26027 3.70688 1.22222 3.61111 1.22222C3.51534 1.22222 3.42349 1.26027 3.35577 1.32799C3.28805 1.39571 3.25 1.48756 3.25 1.58333L3.25 3.75C3.25 3.84577 3.28805 3.93762 3.35577 4.00534C3.42349 4.07306 3.51534 4.11111 3.61111 4.11111Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.38888 4.11111C9.48465 4.11111 9.57651 4.07306 9.64423 4.00534C9.71195 3.93762 9.74999 3.84577 9.74999 3.75V1.58333C9.74999 1.48756 9.71195 1.39571 9.64423 1.32799C9.57651 1.26027 9.48465 1.22222 9.38888 1.22222C9.29311 1.22222 9.20126 1.26027 9.13354 1.32799C9.06582 1.39571 9.02777 1.48756 9.02777 1.58333V3.75C9.02777 3.84577 9.06582 3.93762 9.13354 4.00534C9.20126 4.07306 9.29311 4.11111 9.38888 4.11111Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.69446 2.66666L8.30557 2.66666V3.38889L4.69446 3.38889V2.66666Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_583_1216"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 13,
    height: 13,
    fill: "white",
    transform: "translate(0 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendarWhite);
export default __webpack_public_path__ + "static/media/calendarWhite.fcdb6183fb28486658b09ea47bf6e128.svg";
export { ForwardRef as ReactComponent };